import React, { useContext, useState, useEffect } from 'react';
import OtpInput from 'react-otp-input';
import MailLockIcon from '@mui/icons-material/MailLock';
import { Box, Dialog, DialogContent, Typography, Button } from '@mui/material';
import { toast } from 'react-toastify';
import useStore from '../../../states/store';
import useLoginContext from '../context/useLoginContext';
import { generateOTP, verifyOTP } from '../../../api/loginApi';

function OTPModal() {
  const { form, otpModal, setOtpModal } = useContext(useLoginContext);
  const setAuth = useStore((state) => state.setAuth);
  const [otpcode, setOtp] = useState('');
  const [counter, setCounter] = useState(300);
  const [loading, setLoading] = useState(true);

  const handleResendOtp = async () => {
    toast.loading('Processing reqeust please kindly wait..');
    const response = await generateOTP(form);
    if (response?.status === 200) {
      setOtpModal({ ...otpModal, otp: response?.data });
      setCounter(300);
    }
    toast.dismiss();
  };

  const handleVerfiyOtp = async (e) => {
    e.preventDefault();
    try {
      toast.loading('Processing reqeust please kindly wait..');
      setLoading(true);
      const request = {
        username: form.username,
        password: form.password,
        otp: otpcode,
      };

      const response = await verifyOTP(request);
      const { authenticated, data, token: accessToken } = response.data;

      if (!authenticated && response?.data?.status === 401) {
        toast.error(response?.data?.message);
        return;
      }

      setAuth({ ...data, token: accessToken });

      setLoading(false);
      toast.dismiss();
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (counter > 0) {
      setTimeout(() => setCounter(counter - 1), 1000);
    }
  }, [otpModal ? counter : null]);

  function getMinAndSec(seconds) {
    const min = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${min.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  const countDown = getMinAndSec(counter);
  return (
    <Dialog
      open={otpModal.toggle}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      fullWidth='md'
    >
      <DialogContent>
        <Box justifyItems='center' justifyContent='center'>
          <Box sx={{ backgroundColor: '#5aff47', borderRadius: '100%' }} p={2}>
            <MailLockIcon sx={{ fontSize: '100px', color: '#fff' }} />
          </Box>
          <Typography variant='h4' mt={2} sx={{ fontWeight: 'bold' }}>
            OTP Verfication
          </Typography>
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant='body1' mt={2} style={{ fontSize: '20px' }}>
            Enter the verfication code that was sent to{' '}
            <b>{otpModal?.otp?.otp_destination_masked}</b>
          </Typography>
        </Box>

        <Box justifyItems='center' mt={3} justifyContent='center'>
          <OtpInput
            value={otpcode}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span>&nbsp;</span>}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(props) => <input {...props} />}
            inputStyle={{
              height: '50px',
              width: '50px',
              borderRadius: '10px',
              borderColor: '#dedede',
              backgroundColor: '#f5f5f5',
              fontSize: '20px',
            }}
          />
        </Box>
        <Box justifyItems='center' justifyContent='center' mt={2} pl={12} pr={12}>
          <Button
            onClick={(e) => handleVerfiyOtp(e)}
            variant='contained'
            color='success'
            fullWidth
            loading={loading}
            loadingPosition='end'
          >
            Verify
          </Button>
          <Typography variant='body1' mt={2} style={{ fontSize: '15px' }} gutterBottom>
            {`Didn't get the code?`}
            {counter === 0 ? (
              <Button onClick={handleResendOtp} variant='link' sx={{ color: '#0000FF' }}>
                Resend Code
              </Button>
            ) : (
              <b> {countDown}</b>
            )}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default OTPModal;
